export const getUTCConvertedDate = (utcDateString) =>{
    const utcDate = new Date(utcDateString);
    // Add 5 hours and 30 minutes to the UTC date to get Indian Standard Time (IST)
    const istDate = new Date(
      utcDate.getTime() + 5 * 60 * 60 * 1000 + 30 * 60 * 1000
    );


    return istDate.toISOString()?.slice(0, 10)

}

export const row_per_page_data = [10, 5, 15, 20,25]